import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import {SettingsContext} from '../components/userSettingsContext';
import { useState, useEffect, useContext, forwardRef, useImperativeHandle, useRef  } from "react"

import {CcStepper2, StepperNavButtons} from "../commonComponents/stepper"
import { IconButton, Dialog, DialogActions, FormGroup, FormControlLabel, Radio, Typography  } from '@mui/material';
import { CcActionButton, CcTitle, CcSubSectionTitle } from "../commonComponents/styledTexts";
import {ExclamationCircleIcon } from '@heroicons/react/20/solid'


import dayjs from 'dayjs';

import axios from 'axios';

import {CcLoader, InfoToolTip, LionLoaderGradient} from '../commonComponents/generalComponents'
import {SnippetCodeViewer} from '../commonComponents/snippetGeneric'
import {CcCheckbox, InputNumber, InputText, InputURL, FileSelector, LionCombo, LionListbox} from '../commonComponents/inputFields'


import { Icon as Iconify } from '@iconify/react';

import { getErrorListFromYupError, getErrorMessage, getErrorMessageForArray, snippetDataValidationSchemaImageOptimiser, webPageSettingsValidationSchemaMemoryCards } from '../components/helperErrors'
import { ccColorTeal, ccColorDarkTeal } from '../components/helpersStyles';
import {LionColorPicker, LionMultiColorPicker}  from '../components/lionColorPicker';
import { lionIcons } from '../components/helpersIcons';

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader


export function ImageOptimiserAssetsManager(props) {
  /*
  props:
  templateId: (must be provided for new )
  snippetInfo: (must be provided for edits )

  onChange: returns all the snippet info
  */

  const {settings, setSettings} = useContext(SettingsContext);

  const [snippetName, setSnippetName] = useState('')
  const [snippetDesc, setSnippetDesc] = useState('')
  const [snippetSettings, setSnippetSettings] = useState({ images: [{imgB64: '', tagId: undefined}]})


  useEffect(() => {
    if (props.snippetInfo) {
      //console.log(props.snippetInfo)
      setSnippetName(props.snippetInfo.snippetName)
      setSnippetDesc(props.snippetInfo.snippetDesc)
      setSnippetSettings(props.snippetInfo.snippetSettings)
    }
    else {
      
    }
  }, [props.templateId, props.snippetInfo, settings])


  const prepareDataToPost = (updatePropName, updatePropValue) => {
    const result = {snippetId: 0, snippetName: '', snippetDesc: '', 
    labels: [{labelId: 0, labelName: ''}], href: '',
    snippetTypeId: 24,
    filters: [], orderBy: [],
    dataConnectionId: 0, templateId: 0, dataConnectionInfo: {}};

    result.snippetName = snippetName;
    result.snippetDesc = snippetDesc;
    result.snippetSettings = snippetSettings;
    result.href = props.snippetInfo.href;

    if (updatePropName) {
      result[updatePropName] = updatePropValue;
    }
      //console.log(result)
      return result;
  }

  const handleSnippetNameChange = (newValue) => {
    setSnippetName(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetName', newValue))
  }
  const handleSnippetDescChange = (newValue) => {
    setSnippetDesc(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetDesc', newValue))
  }
  const handleSnippetHrefChange = (newValue) => {
    if (props.onChange) props.onChange(prepareDataToPost('href', newValue))
  }

  const handleImageChange = (index, dataURL) => {

    const newImages = [...snippetSettings.images]
    newImages.splice(index, 1, {imgB64: dataURL})

    const newSnippetSettings = {...snippetSettings, images: newImages }
    setSnippetSettings(newSnippetSettings)
    if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSnippetSettings))

  }


const handleAddImage = () => {
  const newImages = [...snippetSettings.images]
  
  newImages.push({imgB64: ''})

  const newSnippetSettings = {...snippetSettings, images: newImages }
  setSnippetSettings(newSnippetSettings)
  if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSnippetSettings))
}

const handleRemoveImage = (index) => {
  //NOTE: the index param refers to the index of an array of ONLY images not coming from a tag
  //here we have all the images mixed together so we need to first filter

  const newImages = [...snippetSettings.images]
  let filteredIndex = -1
  let finalIndex = -1
  for (let i=0; i<newImages.length; i+=1) {
    if (newImages[i].tagId && newImages[i].tagId > 0) continue
    filteredIndex +=1
    if (filteredIndex === index) {
      finalIndex = i
      break
    }
  }
  
  newImages.splice(finalIndex, 1)

  const newSnippetSettings = {...snippetSettings, images: newImages }
  setSnippetSettings(newSnippetSettings)
  if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSnippetSettings))

}


  return <div className='text-ccColorDarkTeal p-2 flex flex-col'>
    <div className='flex flex-row gap-x-4'>
      <div className="w-96">
        <InputText
                displayName="Name"
                value={snippetName}
                onChange={(val) => {handleSnippetNameChange(val);}}
                error={getErrorMessage(props.validationErrorsList, 'snippetName')}
        />
      </div>

      <div className="w-96">
        <InputText
                  displayName="Description"
                  value={snippetDesc}
                  onChange={(val) => {handleSnippetDescChange(val);}}
                  error={getErrorMessage(props.validationErrorsList, 'snippetDesc')}
        />
      </div>
    </div>
    <div className='flex flex-col w-96 mt-2'>
      <div className="block text-sm font-medium text-ccColorDarkTeal font-poppins">
        Href
      </div>
      <InputURL
        value={props.snippetInfo.href}
        onChange={(val) => {handleSnippetHrefChange(val);}}
        error={getErrorMessageForArray(props.validationErrorsList, 'expirySettings', 'expired-href')}
        />
    </div>
    <div className='mt-2'>
        <div>Upload the images you wish to optimise</div>
        {getErrorMessage(props.validationErrorsList, 'snippetSettingsImagesCount')?.length > 0 && 
          <div className='flex flex-row items-center text-red-500 gap-x-1'>
            <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />

            {getErrorMessage(props.validationErrorsList, 'snippetSettingsImagesCount')}
          </div>
        }

        {snippetSettings.images.filter(c => c.tagId === undefined).map((c, index) => <>
            <div className='flex flex-row gap-x-4 items-center'>
                <FileSelector noDeleteButton
                text="Upload image"
                onChange={(dataUrl) => handleImageChange(index, dataUrl)}
                />
                <div>
                    {c.imgB64 === '' && <div className='bg-slate-200 rounded p-4 mt-2 w-[400px] h-[300px] flex flex-col justify-center items-center'>
                        <Iconify icon="carbon:no-image" width={200} />
                        <div className='font-poppins font-semibold'>No image uploaded</div>
                    </div>

                    }
                    {c.imgB64 !== '' &&
                    <div className='bg-slate-200 rounded p-4 mt-2 w-[400px] h-[300px] flex justify-center'>
                        <div className='relative h-full' >

                            <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${c.imgB64}`} />

                        </div>
                    </div>
                    }
                    {getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsImages', index) && getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsImages', index).length > 0 && <div className='flex flex-row items-center text-red-500 gap-x-1 mb-8'>
                        <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />

                        {getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsImages', index)}
                        </div>
                    }

                </div>
                {!props.isEdit &&
                  <div>
                      <IconButton 
                          onClick={() => handleRemoveImage(index)}
                      ><Iconify icon={lionIcons.Icon_Actions_Cancel} width={36} /></IconButton>
                  </div>                
                }

            </div>
        </>)
        }

    </div>

      {!props.isEdit &&
        <CcActionButton className="w-fit mt-4"
          onClick={handleAddImage}
        >Add another image</CcActionButton>
      }
    </div>

}

const OptimiserStrategyManager = (props) => {


  const handleUpdateStrategy = (propName, propValue) => {
    const newStrategy = {...props.snippetSettings.strategy, [propName]: propValue}
    const newSnippetSettings = {...props.snippetSettings, strategy: newStrategy}

    if (props.onChange) props.onChange(newSnippetSettings)

  }

  const handleResetStats = (reset) => {

    if (props.onResetStatsChange) props.onResetStatsChange(reset)

  }

    return <>
      <CcSubSectionTitle>Select strategy</CcSubSectionTitle>
        <div class="inline-flex rounded-md shadow-sm font-poppins mt-2 text-ccColorDarkTeal" role="group">
          <div className={`cursor-pointer px-4 py-2 w-80 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-s-lg hover:bg-gray-100 hover:text-ccColorTeal ${props.snippetSettings.strategy.strategyType === 'optimise' ? 'bg-gray-200' : 'bg-white'}`}
                onClick={()=>handleUpdateStrategy('strategyType', 'optimise')}>
            <div>
              Optimise
            </div>
            <div className='text-sm mt-2 font-normal'>We will automatically select the winner image and serve that </div>
          </div>
          <div className={`cursor-pointer px-4 py-2 w-80 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-e-lg hover:bg-gray-100 hover:text-ccColorTeal ${props.snippetSettings.strategy.strategyType === 'spread' ? 'bg-gray-200' : 'bg-white'}`}
              onClick={()=>handleUpdateStrategy('strategyType', 'spread')}>
            <div>
              Spread
            </div>
            <div className='text-sm mt-2 font-normal'>We will equally spread the images among the recipients. When the campaign is over you can check which image was best</div>
          </div>
        </div>
        {props.snippetSettings.strategy.strategyType === 'optimise' && <div className='mt-2'>
          <div className='w-56'>
            <InputNumber displayName='Threshold'
                value={props.snippetSettings.strategy.threshold}
                max={20000}
                min={100}
                onChange={(val) => handleUpdateStrategy('threshold', val)}
            />
          </div>
          
        </div>
        }
        {props.showUpdateWarning && <div className='mt-4 border border-ccColorTeal rounded px-2 py-1 w-[640px] text-ccColorTeal font-poppins'>
          <div className='flex flex-row items-center gap-x-1'>
            <Iconify icon={lionIcons.Icon_Alert_Warning} width={22} />
            <div className='font-semibold'>Before updating</div>
          </div>
          <div className=''>You can optionally reset the stats before updating this element</div>
          <div className='font-semibold mt-2'>Important: resetting the stats can affect how this tag works</div>
          <div className=''>If you are using the Optimise strategy, a new optimisation will start even if there was alredy a winner variant</div>
          <div className=''>If you are using the Spread strategy, the reports will only show the numbers from after this update</div>

          <div className='font-semibold mt-2'>Reset stats?</div>
          <div className='flex flex-row gap-x-4 cursor-pointer -mt-2'>
            <div className='flex flex-row items-center -ml-3' onClick={() => {handleResetStats(true)}}>
              <Radio
                checked={props.resetStats}
                onChange={() => handleResetStats(true)}
                name="radio-coverType"
                inputProps={{ 'aria-label': 'A' }}
                sx={{
                  '&.Mui-checked': {
                    color: ccColorTeal,
                  },
                }}
              />
              <div>Yes</div>
            </div>
            <div className='flex flex-row items-center' onClick={() => {handleResetStats(false)}}>
              <Radio
                checked={!props.resetStats}
                onChange={() => handleResetStats(false)}
                name="radio-coverType"
                inputProps={{ 'aria-label': 'A' }}
                sx={{
                  '&.Mui-checked': {
                    color: ccColorTeal,
                  },
                }}
              />
              <div>No</div>
            </div>
          </div>
          </div>}
    </>
} 

export default function ImgOptimiserWorkflow(props) {
    const [currentStep, setCurrentStep] = useState(0);
    const navigate = useNavigate();


    const [snippetData, setSnippetData] = useState({snippetName: '', snippetDesc: '', 
                  snippetSettings: {images: [{imgB64: ''}, {imgB64: ''}], strategy: {strategyType: 'optimise', threshold: 1000} }});


    const [successHtmlMsg, setSuccessHtmlMsg] = useState('');
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [resetStats, setResetStats] = useState(false); //only used when updating a tag
    const [isEdit, setIsEdit] = useState(false);

    const [activeErrorList, setActiveErrorList] = useState([]);

    let params = useParams();
    useEffect(() => {
      if (params.snippetId !== undefined) {
        getSnippetInfo(params.snippetId)
        setIsEdit(true)
      }
      else setIsEdit(false)
    }, [props.snippetId])

    const getSnippetInfo = async (snippetId) => {
      
      try {  
        const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
        const response = await axios.get(url);

        const newSnippetData = response.data;
        newSnippetData.snippetSettings = JSON.parse(response.data.snippetSettings);
        //console.log(newSnippetData.snippetSettings)
        //adding new metadata for compatibility with old tags that don't have it
        setSnippetData(newSnippetData)


      } catch (error) {
        console.log(error);
      }
      
    }

  const submitDataSnippet = async () => {

    setShowLoader(true);
    setSuccessHtmlMsg('');
  
    try {
        let url = `${process.env.REACT_APP_LION_API_URL}/Snippets/create/24`;
        if (params.snippetId !== null && params.snippetId !== undefined) url = `${process.env.REACT_APP_LION_API_URL}/Snippets/update/24/${params.snippetId}`;

        const snippetSettingsToPost = {...snippetData.snippetSettings}

        //console.log(snippetSettingsToPost)
        const dataToPost = {...snippetData, snippetSettings: JSON.stringify(snippetSettingsToPost),
                            resetStats: resetStats
                            }

        const response = await axios.post(url, dataToPost);
  
        setSuccessHtmlMsg(response.data);
        setShowSuccessMsg(true);
    } catch (error) {
      setShowSuccessMsg(false);
      setShowErrorMsg(true);
      console.log(error);
    }
    setShowLoader(false);
    setSubmitted(true)

    return true;
  }
  const handleElementChange = (snippetInfo) => {
    //console.log(snippetInfo)
    setSnippetData(snippetInfo)

    if (activeErrorList.length > 0) {
      try {
        snippetDataValidationSchemaImageOptimiser.validateSync(snippetInfo, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return;
      }  
    }
  }
  const handleElementSnippetSettingsChange = (snippetSettings) => {
    //console.log(snippetSettings)
    const newSettings = {...snippetData, snippetSettings: snippetSettings}
    setSnippetData(newSettings)
    //setPartialRevealPreviews(Array(snippetSettings.revealImages.length).fill(''));


    if (activeErrorList.length > 0) {
      try {
        snippetDataValidationSchemaImageOptimiser.validateSync(newSettings, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return;
      }  
    }
  }

  const handleNavChange = async(navInfo) => {
    if (navInfo.actionType === 'Navigation'){
      //if we are moving from 0 to 1 we need to apply some validation
      if (currentStep === 0 && navInfo.nextIndex === 1) {
        try {
          //console.log(snippetData)
          snippetDataValidationSchemaImageOptimiser.validateSync(snippetData, {abortEarly: false});
          setActiveErrorList([])
        }
        catch (e) {
          //console.log(JSON.parse(JSON.stringify(e)))
          const errorList = getErrorListFromYupError(e)
          //legacy issue: yup can return also href errors that we don't validate anymore
          // in this step. We need to supress this error here
          const hrefErrorIndex = errorList.findIndex(e => e.fieldName === 'snippetSettingsRevealHref');
          if (hrefErrorIndex !== -1) errorList.splice(hrefErrorIndex, 1);
          
          
          //console.log(errorList)
          setActiveErrorList(errorList)
          if (errorList.length > 0) return false;
        }    
      }
      setCurrentStep(navInfo.nextIndex);
    }
    else if (navInfo.actionType === 'Submit') {

      //if we are here then the validastion is passed
      setCurrentStep(navInfo.nextIndex);
      submitDataSnippet()
      
    }
  }
    
    const handleClose = () => {
        navigate("/ph/imgOptimiser")
    }
    

    return <div>
        <CcStepper2
            steps={[{ name: 'Assets', href: '#' },
                    { name: 'Optimising strategy', href: '#' },
                    { name: 'Get Element', href: '#' },
                ]}
            currentStepIndex={currentStep}
        />
        <div className="border border-2 border-gray-200 rounded-md p-2">

            {currentStep === 0 && <ImageOptimiserAssetsManager
                                    onChange={handleElementChange}
                                    validationErrorsList={activeErrorList}
                                    snippetInfo={snippetData}
                                    isEdit={isEdit}
              />}
            {currentStep === 1 && <><OptimiserStrategyManager
                                    onChange={handleElementSnippetSettingsChange}
                                    onResetStatsChange={setResetStats}
                                    validationErrorsList={activeErrorList}
                                    snippetSettings={snippetData.snippetSettings}
                                    showUpdateWarning={params.snippetId}
                                    resetStats={resetStats}
              />
            </>
            }

            {currentStep === 2 && <div className='flex flex-col items-center'>
                {!showLoader && !showSuccessMsg && !showErrorMsg && <div>Confirm</div> }
                {showLoader && <div className='py-12'><CcLoader size={96} /></div> }
                {showSuccessMsg && <SnippetCodeViewer numSnippets={1} html={successHtmlMsg} />}
                {(showSuccessMsg || showErrorMsg) && <div> <CcActionButton variant="contained" onClick={handleClose} >Close</CcActionButton></div>}
            </div>}

            {currentStep !== 2 &&
                    <StepperNavButtons totalSteps={3}
                    currentStepNum={currentStep}
                    onChange={handleNavChange}
                    showClose={submitted}
                    onClose={handleClose}
                />
            }
        </div>

    </div>
}